import createStore from 'unistore';
import countries from 'state/countries';
import filters from 'state/filters';
import map from 'state/map';
import view from 'state/view';
import breakdown from 'state/breakdown';
import accordian from 'state/accordian';

const store = createStore({
	breakdown: breakdown.getInitialState(),
	map: map.getInitialState(),
	filters: filters.getInitialState(),
	countries: countries.getInitialState(),
	accordian: accordian.getInitialState(),
	...view.getInitialState()
});

export default store;



// WEBPACK FOOTER //
// ./state/store.js